import React, { useEffect, useState } from "react";
import './TablaBitacoras.scss'
import InputText from "../../atoms/InputText/InputText";
import TextArea from "../../atoms/TextArea/TextArea";
import ButtonGris from "../../atoms/ButtonGris/ButtonGris";
import Button from "../../atoms/Button/Button";
import { extraerHora, formateoBasico, isoAUtc } from "../../../utilities/formateos";
import { getTiempoBitacora, updateTime } from "./TablaBitacorasntegracion";
import Swal from "sweetalert2";
import { jwtDecode } from "jwt-decode";



const ModalCambioDeHorario = ({ data, setShowCambiarHora }) => {
    const [horaInicio, setHoraInicio] = useState(data.tiempoInicio.split(":")[0] + ":" + data.tiempoInicio.split(":")[1])
    const [horaFin, setHoraFin] = useState(data.tiempoFin.split(":")[0].trimStart() + ":" + data.tiempoFin.split(":")[1])
    const [fecha,setFecha]=useState(formateoBasico(new Date()))
    const [notasFacturacion,setNotasFacturacion]=useState("")
    const [getInfoBitacora,setGetInfoBitacora]=useState("")
    const [usuarioToken,setUsuarioToken]=useState()
    const [textAnterior,setTextAnterior]=useState("")
    const submitTime = ()=>{
        if(notasFacturacion)
        {
            const dataupdate = {
                horaArranque: fecha+" "+horaInicio+":00",
                horaLlegada: fecha+" "+horaFin+":00",
                nota: textAnterior +"  |  " + usuarioToken.NOMBRE+" | .... " + notasFacturacion,
                id_bitacora: data.bitacora
            }
            updateTime(dataupdate,setShowCambiarHora)
        }
        else{
            Swal.fire({
                icon: 'error',   // Icono de error
                title: 'Oops...', // Título de la alerta
                text: 'rellena todos los campos obligatorios', // Mensaje de error
                confirmButtonText: 'OK'  // Texto del botón de confirmación
              });
        }
    }

    useEffect(()=>
    {
        getTiempoBitacora(setGetInfoBitacora,data.bitacora)
        const dataToken  = jwtDecode(sessionStorage.getItem('token'))
        setUsuarioToken(dataToken)
    },[])
    useEffect(()=>
    {
        if(getInfoBitacora)
        {
    
            
            setHoraInicio(extraerHora(getInfoBitacora.HORA_ARRANQUE))
            setHoraFin(extraerHora( getInfoBitacora.HORA_LLEGADA))
            setTextAnterior(getInfoBitacora.COMENTARIOS)
        }
    },[getInfoBitacora])
 
    
    return (
        <div className="modalContorn">
            <div className="modal">
                <div className="titleN">Cambio Individual Horario (id: {data.bitacora})</div>
                <div className="titleN">{data.ruta}</div>
                <div className="margen">
                    <div className="containerCEDN">
                        <div className="cont">
                            <InputText title="Tiempo Inicial" value={horaInicio} onChange={(e) => { setHoraInicio(e.target.value) }} type="time"></InputText>
                        </div>
                        <div className="cont">
                            <InputText title="Tiempo Final" value={horaFin} onChange={(e) => { setHoraFin(e.target.value) }} type="time"></InputText>
                        </div>
                    </div>
                    <TextArea onChange={(e)=>{setNotasFacturacion(e.target.value)}} value={notasFacturacion} titulo={"Nota para facturación"} className={"textAreaClass"}></TextArea>
                    <div className="containerButtons">
                        <ButtonGris onClick={() => { setShowCambiarHora(null) }}>Cancelar</ButtonGris>
                        <Button onClick={()=>{submitTime()}}>Modificar</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ModalCambioDeHorario